import React from 'react';
import PropTypes from 'prop-types';

import styles from './CreditBreakdownRestrictions.scss';

export default function CreditBreakdownRestrictions({ heading, items }) {
  return (
    <div className={styles.creditBreakdownRestrictions}>
      <h4 className={styles.heading}>{heading}</h4>
      <ul className={styles.restrictions}>
        {items.map((item) => (
          <li key={`restrictions-item-${item}`}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

CreditBreakdownRestrictions.propTypes = {
  heading: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};
